// @LTG-ID: app-root
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 07_PAGES_AND_ROUTES.md, ORCH-0050 A5 (explicit per-route
//        registration for published briefs; :slug catch-all → JournalNotFound)
// @CHANGED: 2026-05 session_006 (CHG-0083-M-A1 — mount /contact)
// @OWNER: web
//
// App root. Wires React Router, mounts SiteLayout on every route.
//
// Route registry (order matters — react-router-v7 matches explicit paths
// before `:slug` catch-all; explicit always wins):
//   "/"                                       → Home
//   "/journals"                               → Journals (index, P3-M4 placeholder today)
//   "/journals/what-is-my-business-worth"     → Brief01 (P3-M2)
//   "/journals/sde-vs-ebitda"                 → Brief02 (P3-M3)
//   "/journals/:slug"                         → JournalNotFound (P3-M2 catch-all)
//   "/refund-policy"                          → RefundPolicy
//   "/contact"                                → ContactPage (CHG-0083-M-A1, F-080)
//
// JournalBrief (the legacy "Phase 4 placeholder" page) is retired from routing
// as of CHG-0060; the file remains on disk for now until P3-M3 lands Brief 02,
// at which point it is deleted in a follow-up CHG row. Importing it from App.js
// would put a stale name in the bundle.

import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import Journals from "@/pages/Journals";
import Brief01 from "@/pages/Brief01";
import Brief02 from "@/pages/Brief02";
import JournalArticle from "@/pages/JournalArticle";
import JournalNotFound from "@/components/journals/JournalNotFound";
import RefundPolicy from "@/pages/RefundPolicy";
import ContactPage from "@/pages/ContactPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/journals" element={<Journals />} />
                        {/* Legacy hand-JSX briefs (untouched by CHG-0102). */}
                        <Route
                            path="/journals/what-is-my-business-worth"
                            element={<Brief01 />}
                        />
                        <Route
                            path="/journals/sde-vs-ebitda"
                            element={<Brief02 />}
                        />
                        {/* CHG-0102 · Journal MVP · dynamic 20-article route.
                            Explicit legacy routes above match FIRST (React
                            Router v7 prefers exact matches over param routes);
                            JournalArticle handles the 20 slugs registered in
                            data/journals/_index.js and falls through to
                            JournalNotFound for any unknown slug. */}
                        <Route
                            path="/journals/:slug"
                            element={<JournalArticle />}
                        />
                        <Route
                            path="/refund-policy"
                            element={<RefundPolicy />}
                        />
                        <Route path="/contact" element={<ContactPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
